import type {
    UrlInputPagePropertyOnboardingContextFieldsV1,
    UrlInputPagePropertyOnboardingContextIdsV1,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    BackElementPropertyOnboardingManifestV1,
    LearnMoreButtonElementPropertyOnboardingManifestV1,
    NextElementPropertyOnboardingManifestV1,
    SelectLanguageElementPropertyOnboardingManifestV1,
    UrlInputFieldElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import {
    UrlInputPagePropertyOnboardingContextManifestV1,
    WebUrlInputVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/url-input-page";
import {
    CarouselButtonsElementPropertyOnboardingManifestV1,
    FindTheUrlSectionElementPropertyOnboardingManifestV2,
    ImportSpecificListingSectionElementPropertyOnboardingManifestV2,
    ImportTabElementPropertyOnboardingManifestV1,
    LimitListingNumberSectionElementPropertyOnboardingManifestV2,
    TypeOfInfoSectionElementPropertyOnboardingManifestV2,
    TypeOfListingSectionElementPropertyOnboardingManifestV2,
} from "@agoda/analytics-messages-definition/manifest/elements";
import { BaseContextFieldsMapping, GetAttributeNumberSafe } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const urlInputBinder = defineBinder(({ webAnalytics, action: { click } }) => {
    webAnalytics.pageContext<UrlInputPagePropertyOnboardingContextIdsV1, UrlInputPagePropertyOnboardingContextFieldsV1>(
        UrlInputPagePropertyOnboardingContextManifestV1.ids,
        {
            auth_user_id: BaseContextFieldsMapping.auth_user_id,
            member_id: BaseContextFieldsMapping.member_id,
            property_id: BaseContextFieldsMapping.property_id,
            is_internal_user: BaseContextFieldsMapping.is_internal_user,
        },
    );

    webAnalytics.observe(WebUrlInputVisitEventPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], SelectLanguageElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], NextElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], BackElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], UrlInputFieldElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], LearnMoreButtonElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], FindTheUrlSectionElementPropertyOnboardingManifestV2.ids, {
        property_import_source: (element: HTMLElement) => GetAttributeNumberSafe(element, "data-source"),
    });
    webAnalytics.observeElement([click], TypeOfInfoSectionElementPropertyOnboardingManifestV2.ids, {
        property_import_source: (element: HTMLElement) => GetAttributeNumberSafe(element, "data-source"),
    });
    webAnalytics.observeElement([click], ImportSpecificListingSectionElementPropertyOnboardingManifestV2.ids, {
        property_import_source: (element: HTMLElement) => GetAttributeNumberSafe(element, "data-source"),
    });
    webAnalytics.observeElement([click], LimitListingNumberSectionElementPropertyOnboardingManifestV2.ids, {
        property_import_source: (element: HTMLElement) => GetAttributeNumberSafe(element, "data-source"),
    });
    webAnalytics.observeElement([click], TypeOfListingSectionElementPropertyOnboardingManifestV2.ids, {
        property_import_source: (element: HTMLElement) => GetAttributeNumberSafe(element, "data-source"),
    });
    webAnalytics.observeElement([click], CarouselButtonsElementPropertyOnboardingManifestV1.ids, {
        action_element_index: (element: HTMLElement) => GetAttributeNumberSafe(element, "data-value"),
    });
    webAnalytics.observeElement([click], ImportTabElementPropertyOnboardingManifestV1.ids, {
        property_import_source: (element: HTMLElement) => GetAttributeNumberSafe(element, "data-source"),
    });
});
